// extracted by mini-css-extract-plugin
export var inputContainer = "_n2-0";